import styles from "./Updates.module.css";
import SocialLink from "../UI/SocialLink";
import PrimaryBtn from "../UI/PrimaryBtn";
import whatsappImg from "../../assets/icons/whatsapp-dark.png";
import facebookImg from "../../assets/icons/facebook-dark.png";
import instagramImg from "../../assets/icons/instagram-dark.png";

const Updates = () => {
  return (
    <div className={styles.section}>
      <h5 className={styles.title}>To get latest updates</h5>
      <form className={styles.formControl}>
        <input className={styles.input} type="text" />
        <PrimaryBtn className={styles.btn}>Confirm</PrimaryBtn>
      </form>
      <div className={styles.linksContainer}>
        <SocialLink
          linkClassName={styles.linkBtn}
          href="#"
          src={whatsappImg}
          alt="whatsapp"
        />
        <SocialLink
          linkClassName={styles.linkBtn}
          href="#"
          src={instagramImg}
          alt="instagram"
        />
        <SocialLink
          linkClassName={styles.linkBtn}
          href="#"
          src={facebookImg}
          alt="facebook"
        />
      </div>
    </div>
  );
};

export default Updates;
